import script from "./dynamic-news-band.vue?vue&type=script&lang=js"
export * from "./dynamic-news-band.vue?vue&type=script&lang=js"

import "./dynamic-news-band.vue?vue&type=style&index=0&id=2ac170a2&lang=scss"

const __exports__ = script;

export default __exports__